// Zihin Mimarı - Conversation Flow Data
// Taner Torun Metodolojisi ile Hipnotik Dil Kalıpları

export const systemDescriptions = {
  "Dijital Deneyim & Algı Mimarisi": "Nöro-UX ve hipnotik arayüz tasarımıyla, ziyaretçiyi güven ve aksiyona taşıyan bir algı sistemine dönüştürür. Ortalama sonuç: %240 dönüşüm artışı.",
  "Otorite & Talep Motoru": "SEO'yu bir trafik aracı değil, sektörde otorite ve nitelikli talep üreten bir içerik motoru olarak kurgular. Ortalama sonuç: Nitelikli organik lead %180 artış.",
  "Performans & İkna Hızlandırıcı": "Reklamı 'harcama' olmaktan çıkarır; ikna psikolojisiyle tasarlanan kreatif, huni ve ölçüm sistemleriyle büyümeyi hızlandırır. Ortalama sonuç: ROAS %320 iyileşme.",
  "Veri Zekası & Sadakat Sistemleri": "Büyümeyi sadece yeni müşteri kazanımıyla değil; elde tutma, tekrar satın alma ve LTV artırımıyla sürdürülebilir hale getirir. Ortalama sonuç: Retention rate %65 artış.",
  "aifabric Kurumsal Entegrasyon": "Yapay zekâyı sadece pazarlamada değil; satış, destek ve operasyon süreçlerinde de uygulanabilir hale getirir. Ortalama sonuç: Operasyon verimliliği %45 artış."
};

export const bottleneckToSystem = {
  "conversion_issue": "Dijital Deneyim & Algı Mimarisi",
  "perception_issue": "Otorite & Talep Motoru",
  "performance_issue": "Performans & İkna Hızlandırıcı",
  "retention_issue": "Veri Zekası & Sadakat Sistemleri",
  "efficiency_issue": "aifabric Kurumsal Entegrasyon"
};

export const conversationFlow = {
  stage_0_entry: {
    messages: [
      { text: "Merhaba.", delay: 800 },
      { text: "Ben Zihin Mimarı Taner Torun'un dijital asistanıyım.", delay: 1200 },
      { text: "Buradasınız, çünkü markanızın sadece 'var olmasını' değil, **'hissedilmesini'** ve **'seçilmesini'** istiyorsunuz.", delay: 1500 },
      { text: "Sizi ve markanızı **3 kısa soruda teşhis** etmeme izin verin.", delay: 1000 },
      { text: "Hazır mısınız?", delay: 500 }
    ],
    options: [
      { id: "ready_yes", label: "✅ Evet, hazırım.", next: "stage_1_diagnosis_intro" },
      { id: "methodology_first", label: "🧠 Önce metodolojiyi duymalıyım.", next: "stage_methodology_brief" },
      { id: "services_first", label: "🚀 Hizmetlerinizi görmek istiyorum.", next: "stage_services_overview" }
    ]
  },

  stage_methodology_brief: {
    messages: [
      { text: "Metodolojimiz **20 yıllık** bir birikimin eseridir:", delay: 1000 },
      { text: "🧠 **Nöro-Pazarlama:** Zihinlerde iz bırakan tasarım.\n\n🗣️ **Hipnotik Dil Kalıpları:** Etik ikna ve mesaj mimarisi.\n\n🤖 **aifabric Yapay Zeka:** Veriyi içgörüye çeviren zeka katmanı.", delay: 1500 },
      { text: "Biz kod yazmıyoruz; müşterinizin zihnindeki **'güven' ve 'sempati' düğmelerine** basan sistemler kuruyoruz.", delay: 1200 },
      { text: "Şimdi teşhise geçebiliriz, değil mi?", delay: 800 }
    ],
    options: [
      { id: "start_diagnosis", label: "✅ Evet, başlayalım.", next: "stage_1_diagnosis_intro" }
    ]
  },

  stage_services_overview: {
    messages: [
      { text: "Medyatik Interactive, 5 ana **Büyüme Sistemi** ile çalışır:", delay: 1000 },
      { text: "1️⃣ **Dijital Deneyim & Algı Mimarisi**\nNöro-UX + Hipnotik Tasarım ile güven ve dönüşüm.\n\n2️⃣ **Otorite & Talep Motoru**\nAuthority SEO + İçerik Sistemi ile sektör liderliği.\n\n3️⃣ **Performans & İkna Hızlandırıcı**\nPsikoloji odaklı reklam + dönüşüm hunisi.\n\n4️⃣ **Veri Zekası & Sadakat Sistemleri**\nLTV + Retention + Churn önleme.\n\n5️⃣ **aifabric Kurumsal Entegrasyon**\nİç süreçlerde AI dönüşümü + Hipnotik Satış Eğitimleri.", delay: 2000 },
      { text: "🧠 Tüm sistemler **Taner Torun Metodolojisi** ile güçlendirilir.", delay: 1000 },
      { text: "📊 **150+ proje, %240 ortalama büyüme.**", delay: 800 },
      { text: "Şimdi sizin için en uygun sistemi bulmak üzere teşhise geçelim mi?", delay: 1000 }
    ],
    options: [
      { id: "start_diagnosis", label: "✅ Evet, teşhise geçelim.", next: "stage_1_diagnosis_intro" }
    ]
  },

  stage_1_diagnosis_intro: {
    messages: [
      { text: "Mükemmel.", delay: 600 },
      { text: "Şimdi size **3 kritik soru** soracağım.", delay: 1000 },
      { text: "Bu sorular, markanızın şu anki durumunu ve en hızlı büyüme yolunu netleştirecek.", delay: 1200 },
      { text: "İlk soru:", delay: 800 }
    ],
    autoNext: "stage_1_question_1",
    enableFocusMode: true
  },

  stage_1_question_1: {
    question: "Sektörünüzdeki **en büyük darboğaz** hangisi?",
    subtitle: "(Dürüst cevap verin; bu teşhisin kalitesini belirler.)",
    options: [
      { id: "bottleneck_conversion", label: "🔻 Trafik var ama satış/dönüşüm yok.", value: "Düşük Dönüşüm", tag: "conversion_issue", next: "stage_1_question_2" },
      { id: "bottleneck_perception", label: "👁️ Rakipler arasında fark edilemiyoruz.", value: "Algı Sorunu", tag: "perception_issue", next: "stage_1_question_2" },
      { id: "bottleneck_performance", label: "💸 Reklam maliyetleri çok yüksek.", value: "Performans Sorunu", tag: "performance_issue", next: "stage_1_question_2" },
      { id: "bottleneck_retention", label: "🔄 Müşteriler bir kez gelip gidiyor.", value: "Sadakat Sorunu", tag: "retention_issue", next: "stage_1_question_2" },
      { id: "bottleneck_efficiency", label: "⚙️ İç süreçler yavaş, ekip verimsiz.", value: "Verimlilik Sorunu", tag: "efficiency_issue", next: "stage_1_question_2" }
    ]
  },

  stage_1_question_2: {
    dynamicMessages: (data) => [
      { text: `Anladım. **${data.bottleneck}** gerçekten büyümeyi yavaşlatır.`, delay: 1000 },
      { text: "İkinci soru:", delay: 800 }
    ],
    question: "Hedeflediğiniz **aylık büyüme oranı** nedir?",
    options: [
      { id: "growth_moderate", label: "📈 %20 - %50 arası (Sağlam ve sürdürülebilir)", value: "Orta Ölçekli Büyüme", tag: "moderate_growth", next: "stage_1_question_3" },
      { id: "growth_aggressive", label: "🚀 %100 ve üzeri (Agresif ölçekleme)", value: "Agresif Büyüme", tag: "aggressive_growth", next: "stage_1_question_3" },
      { id: "growth_stable", label: "🏛️ Sürdürülebilir ve stabil bir yapı", value: "Stabil Büyüme", tag: "stable_growth", next: "stage_1_question_3" }
    ]
  },

  stage_1_question_3: {
    dynamicMessages: (data) => [
      { text: `**${data.growth_target}** hedefi net.`, delay: 1000 },
      { text: "Son soru:", delay: 800 }
    ],
    question: "Bu büyümeyi **ne kadar sürede** başlatmak istersiniz?",
    options: [
      { id: "urgency_immediate", label: "⚡ Hemen, kaybedecek vaktimiz yok.", value: "Acil", tag: "urgent", next: "stage_2_system_recommendation" },
      { id: "urgency_planned", label: "📅 Önümüzdeki 1 ay içinde.", value: "Planlı (1 ay)", tag: "planned", next: "stage_2_system_recommendation" },
      { id: "urgency_research", label: "🔍 Sadece bilgi topluyorum (2-3 ay sonra).", value: "Araştırma Aşaması", tag: "research", next: "stage_2_system_recommendation" }
    ]
  },

  stage_2_system_recommendation: {
    dynamicMessages: (data) => {
      const system = bottleneckToSystem[data.bottleneck_tag];
      const description = systemDescriptions[system];
      return [
        { text: "Teşhis tamamlandı.", delay: 1000 },
        { text: `Sizin için en uygun sistem: **${system}**`, delay: 1200 },
        { text: description, delay: 1500 }
      ];
    },
    showDiagnosisScore: true,
    autoNextDelay: 3000,
    nextAfterScore: "stage_2b_roi_intro"
  },

  stage_2b_roi_intro: {
    messages: [
      { text: "Peki şimdi potansiyel büyümenizi somutlaştıralım...", delay: 1000 }
    ],
    showROICalculator: true,
    nextAfterROI: "stage_2c_lead_transition"
  },

  stage_2c_lead_transition: {
    messages: [
      { text: "Bu analizi Taner Torun'a ve ekibine iletmem için bilgilerinizi rica ediyorum.", delay: 1000 },
      { text: "WhatsApp üzerinden size özel bir **'Büyüme Reçetesi'** hazırlayacağım.", delay: 1200 }
    ],
    autoNext: "stage_3_lead_capture"
  },

  stage_3_lead_capture: {
    messages: [
      { text: "Lütfen aşağıdaki bilgileri doldurun:", delay: 800 }
    ],
    form: {
      fields: [
        { id: "name", label: "Adınız Soyadınız", type: "text", required: true, placeholder: "Örn: Ahmet Yılmaz" },
        { id: "company", label: "Markanızın Adı", type: "text", required: true, placeholder: "Örn: ABC Teknoloji" },
        { id: "phone", label: "WhatsApp Numaranız", type: "tel", required: true, placeholder: "Örn: 0532 123 45 67" },
        { id: "email", label: "E-posta Adresiniz", type: "email", required: true, placeholder: "Örn: ahmet@sirket.com" }
      ],
      submitLabel: "Devam Et →",
      next: "stage_4_qualifying_questions"
    }
  },

  stage_4_qualifying_questions: {
    messages: [
      { text: "Mükemmel. Birkaç ek bilgi daha alayım:", delay: 1000 }
    ],
    form: {
      fields: [
        { 
          id: "budget", 
          label: "Bütçe aralığınız (opsiyonel)", 
          type: "select", 
          required: false,
          options: ["Henüz belirlemedim", "50.000 - 100.000 TL", "100.000 - 250.000 TL", "250.000 - 500.000 TL", "500.000 TL+"]
        },
        { 
          id: "timeline", 
          label: "Projeyi ne zaman başlatmak istersiniz?", 
          type: "select", 
          required: false,
          options: ["Henüz belirlemedim", "Hemen (bu hafta)", "1 ay içinde", "2-3 ay içinde", "3+ ay içinde"]
        },
        { 
          id: "additional_message", 
          label: "Projeniz hakkında kısaca bilgi (opsiyonel)", 
          type: "textarea", 
          required: false, 
          placeholder: "Örn: E-ticaret sitemizin dönüşüm oranını artırmak istiyoruz..." 
        }
      ],
      submitLabel: "Analizi Tamamla →",
      next: "stage_5_whatsapp_handoff"
    }
  },

  stage_5_whatsapp_handoff: {
    messages: [
      { text: "Harika. Bilgileri sentezledim ve Taner Torun için bir **'Büyüme Özeti'** oluşturdum.", delay: 1200 },
      { text: "Aşağıdaki butona tıkladığınızda WhatsApp açılacak.", delay: 1000 },
      { text: "Mesajı gönderdiğinizde analiziniz **doğrudan Taner Bey'e** ulaşacak.", delay: 1200 },
      { text: "✅ Gönderimi siz onaylayacaksınız.", delay: 800 }
    ],
    showWhatsAppButton: true
  },

  stage_6_confirmation: {
    messages: [
      { text: "✅ Mükemmel!", delay: 800 },
      { text: "Ekibimiz **15 dakika içinde** sizinle iletişime geçecek.", delay: 1000 },
      { text: "🚀 Acil durumlar için:\nWhatsApp: +90 532 168 62 82", delay: 1200 },
      { text: "Başka bir konuda yardımcı olabilir miyim?", delay: 1000 }
    ],
    options: [
      { id: "restart", label: "🔄 Ana Menüye Dön", action: "restart" },
      { id: "end", label: "👋 Sohbeti Bitir", action: "close" }
    ]
  }
};

export const generateWhatsAppMessage = (data) => {
  const system = bottleneckToSystem[data.bottleneck_tag] || "Belirtilmedi";
  const timestamp = new Date().toLocaleString('tr-TR');
  
  // WhatsApp uyumlu mesaj - emoji yerine metin sembolleri
  const message = `*ZIHIN MIMARI - BUYUME ANALIZI TALEBI*
========================================

>> ILETISIM BILGILERI:
* Isim: ${data.name || 'Belirtilmedi'}
* Marka: ${data.company || 'Belirtilmedi'}
* Telefon: ${data.phone || 'Belirtilmedi'}
* E-posta: ${data.email || 'Belirtilmedi'}

>> TESHIS SONUCLARI:
* Darbogaz: ${data.bottleneck || 'Belirtilmedi'}
* Hedef Buyume: ${data.growth_target || 'Belirtilmedi'}
* Aciliyet: ${data.urgency || 'Belirtilmedi'}
* Ilgilendigi Sistem: ${system}

>> BUTCE & ZAMAN:
* Butce: ${data.budget || 'Belirtilmedi'}
* Baslangic: ${data.timeline || 'Belirtilmedi'}

>> EK NOT:
${data.additional_message || 'Ek not yok'}

========================================
* Bu analiz Taner Torun Metodolojisi ile olusturulmustur.
* Tarih: ${timestamp}

(Lutfen bu mesaji degistirmeden gonderin)`;

  return message;
};

export const generateWhatsAppURL = (data) => {
  const message = generateWhatsAppMessage(data);
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/905321686282?text=${encodedMessage}`;
};
